// Render ready answers immediately. Network/model time remains visible as loading;
// there is no extra delay to imitate a person.
export type Random = () => number;

export function humanReplyDelayMs(_reply: string, _random: Random = Math.random): number {
  return 0;
}

/** Hoe lang er nog gewacht moet worden, gegeven de tijd die al verstreken is. */
export function remainingDelayMs(targetMs: number, startedAt: number, now: number): number {
  return Math.max(0, Math.round(targetMs - (now - startedAt)));
}

/** Written team replies are ready to display; never add artificial typing time. */
export function liveMessageTypingMs(_content: string, _random: Random = Math.random): number {
  return 0;
}

/** Ouder dan dit is een livebericht al "gebeurd": meteen op zijn plek, zonder typfase. */
export const LIVE_MESSAGE_STALE_MS = 60_000;

/**
 * Zet een bericht op volgorde van tijd: vóór het eerste bericht dat later is.
 * Een teambericht van uren geleden dat pas bij de eerste poll binnenkomt, komt
 * zo niet onder het nieuwste antwoord te staan (17-10-2026: "Goedemiddag").
 */
export function insertChronologically<T extends { at?: number }>(messages: T[], message: T): T[] {
  if (message.at === undefined) return [...messages, message];
  const index = messages.findIndex((item) => item.at !== undefined && item.at > (message.at as number));
  if (index === -1) return [...messages, message];
  return [...messages.slice(0, index), message, ...messages.slice(index)];
}
